module.exports = __webpack_public_path__ + "img/team.d8968833.svg";